import { render, staticRenderFns } from "./zongbao.vue?vue&type=template&id=2ec3ea8c&scoped=true&"
import script from "./zongbao.vue?vue&type=script&lang=js&"
export * from "./zongbao.vue?vue&type=script&lang=js&"
import style0 from "./zongbao.vue?vue&type=style&index=0&id=2ec3ea8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec3ea8c",
  null
  
)

export default component.exports